import base from './base'

export default {
  ...base,
  colors: {
    ...base.colors,
    shadow1: '#2F80ED',
    text1: '#333',
    text2: '#585757',
    text3: '#888D9B',
    text4: '#C3C5CB',

    // backgrounds / greys
    bg0: '#F5F3F3',
    bg1: '#FFFDFA',
    bg2: '#F5F3F3',
    bg3: '#EDEEF2',
    bg4: '#CED0D9',
    bg5: '#43d3db',
    modalBG: 'rgba(0,0,0,0.3)',
    advancedBG: 'rgba(255,255,255,0.6)',

    //primary colors
    primary1: '#C6C6C6',
    primary4: '#bfe0e2',
    primary5: '#333',

    // color text
    primaryText1: '#fff',
    buttonText: '#ffffff',

    // secondary colors
    secondary1: '#13aab5'
  }
}
